module.exports = __webpack_public_path__ + "img/h.1b637afe.jpg";